/**
 * Created by lari on 04/03/2017.
 */

(function () {
  'use strict';
  /**
   * @ngdoc directive
   * @name config.component:todowidget
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="todo">
   <file name="index.html">
   <rksv-zero></rksv-zero>
   </file>
   </example>
   *
   */
  
  
  angular
    .module('finance.rksv')
    .component('rksvZero', {
      restrict: 'E',
      template: '<h2>Null-Beleg, Signatur über ausgefallene Signaturen</h2>' +
      '<button class="btn btn-primary" ng-click="vm.createNullBeleg()">Null-Beleg erstellen</button>' +
      '<div class="alert alert-{{vm.status || info}} spacer-top" ng-hide="vm.status === \'init\'">' +
      '<h3>{{vm.message}}</h3>' +
      '<p ng-show="vm.pdfid"><a href="/routes/pdfreader/{{vm.pdfid}}" target="_blank">PDF anzeigen</a></p>' +
      '<p ng-show="vm.hint">{{vm.hint}}</p>' +
      '</div>',
      controllerAs: 'vm',
      controller: ['$log', '$http', 'RksvHelper',
        function ($log, $http, RksvHelper) {
          var vm = this;
          vm.status = 'init';
          vm.createNullBeleg = createNullBeleg;
          
          $log.debug('RKSV zero called');
          
          function createNullBeleg() {
            var invoiceobj = RksvHelper.getNullBeleg();
            
            $http.post('/routes/rksvzero', invoiceobj).then(function (res) {
              vm.status = 'success';
              vm.message = 'Erstellung des Nullbelegs ' + res.data.nbnum + ' war erfolgreich';
              vm.pdfid = res.data.pdfid;
              vm.hint = 'QR Code: ' + res.data.qrcode;
              $log.debug('RKSV zero record sent successfully');
            }, function (res) {
              $log.error('RKSV zero record failed');
              vm.status = 'danger';
              vm.message = 'Erstellung des Nullbelegs ist fehlgeschlagen';
              vm.hint = '';
            });
            
          }
          
        }]
    });
  
  // klammerfriedhof
}());
